import './audio-waveform';

function initWidgets() {
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.posts-list')) {
      const sliders = document.querySelectorAll('.posts-list');
      sliders.forEach((swiperElement) => {
        let init = false;
        let swiper;
        const mq = window.matchMedia('(max-width: 768px)');
        // console.log(init);
        if (mq.matches) {
          if (!init) {
            init = true;
            // eslint-disable-next-line no-undef
            swiper = new Swiper(swiperElement, {
              slidesPerView: 1,
              spaceBetween: 0,
              navigation: true,
              createElements: true,
              slideClass: 'posts-list--item',
              breakpoints: {
                576: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
              },
            });
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.counters-list')) {
      const counters = document.querySelectorAll('.count');

      const animateCounters = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const countEl = entry.target.querySelector('span');
            const targetValue = parseInt(countEl.dataset.target);
            const path = entry.target.querySelector('.progress-path');

            // Animate Counter
            const duration = 2000; // 2 seconds
            let startTime = null;

            const updateCounter = (timestamp) => {
              if (!startTime) startTime = timestamp;
              const progress = timestamp - startTime;
              const value = Math.min(
                Math.floor((progress / duration) * targetValue),
                targetValue
              );
              countEl.textContent = value;
              if (progress < duration) {
                requestAnimationFrame(updateCounter);
              } else {
                countEl.textContent = targetValue; // Ensure final value
              }
            };

            requestAnimationFrame(updateCounter);

            // Animate SVG Stroke
            path.style.strokeDashoffset = '0';

            observer.unobserve(entry.target);
          }
        });
      };

      const observer = new IntersectionObserver(animateCounters, {
        threshold: 0.5,
      });

      counters.forEach((counter) => {
        observer.observe(counter.parentElement);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('.logo-animate-wrapper')) {
      const button = document.getElementById('toggleAnimation');
      if (!button) {
        return;
      }
      const rows = document.querySelectorAll('.logo-animate-wrapper');
      const images = button.querySelectorAll('img');
      let isPaused = false;
      const animationSpeed = 32;

      const setLogoAnimationDuration = () => {
        rows.forEach((row) => {
          const travelDistance = row.scrollWidth / 2;
          if (!travelDistance) {
            return;
          }

          row.style.animationDuration = `${travelDistance / animationSpeed}s`;
        });
      };

      setLogoAnimationDuration();
      window.addEventListener('resize', setLogoAnimationDuration);

      button.addEventListener('click', () => {
        isPaused = !isPaused;
        rows.forEach((row) => {
          row.style.animationPlayState = isPaused ? 'paused' : 'running';
        });
        button.setAttribute(
          'aria-label',
          isPaused ? 'Play logos' : 'Pause logos'
        );
        images.forEach((img) => img.classList.toggle('d-none'));
      });
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const SPLIT_BREAKPOINT = 768;

    let cachedItems = null;

    const getRowSplit = (total) => {
      switch (total) {
        case 5:
        case 6:
          return 3;
        case 7:
          return 4;
        default:
          return Math.min(total, 4);
      }
    };

    const layoutSpeakers = () => {
      const container = document.getElementById('team-listing-speakers');
      if (!container) return;

      if (!cachedItems) {
        cachedItems = Array.from(container.children).filter(
          (el) => el.tagName === 'DIV' && !el.classList.contains('row')
        );
      }

      const items = cachedItems;
      if (items.length === 0) return;

      container.innerHTML = '';

      const useSplit = window.innerWidth >= SPLIT_BREAKPOINT;
      const rows = [];

      if (useSplit) {
        const firstRowCount = getRowSplit(items.length);
        for (let start = 0; start < items.length; start += firstRowCount) {
          const rowItems = items.slice(start, start + firstRowCount);
          const row = document.createElement('div');
          row.className = 'row justify-content-center';
          rowItems.forEach((item) => row.appendChild(item));
          container.appendChild(row);
          rows.push(rowItems);
        }
      } else {
        const row = document.createElement('div');
        row.className = 'row justify-content-center';
        items.forEach((item) => row.appendChild(item));
        container.appendChild(row);
        rows.push(items);
      }

      equalizeTitleHeights(rows);
    };

    const equalizeTitleHeights = (rows) => {
      const titles = rows.map((rowItems) =>
        rowItems
          .map((item) => item.querySelector('.staff-list--item .z__fs-12'))
          .filter(Boolean)
      );

      titles.forEach((rowTitles) => {
        rowTitles.forEach((t) => {
          t.style.minHeight = '';
        });
      });

      requestAnimationFrame(() => {
        titles.forEach((rowTitles) => {
          const max = rowTitles.reduce(
            (m, t) => Math.max(m, t.offsetHeight),
            0
          );
          rowTitles.forEach((t) => {
            t.style.minHeight = `${max}px`;
          });
        });
      });
    };

    layoutSpeakers();

    if (document.getElementById('team-listing-speakers')) {
      let resizeFrame;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => {
          layoutSpeakers();
        });
      });
    }
  });
}
initWidgets();
window.initWidgets = initWidgets;
